import { API_REQUEST, GET_PROPERTY_LIST, REMOVE_PROPERTY, ADD_PROPERTY, SET_CURRENT_ADDRESS, SET_CURRENT_PROPERTY, SET_REDIRECTS, RESET_ADD_PROPERTY, SET_CURRENT_OWNERTYPE, RESET_REMOVE_PROPERTY, ALTERNATE_ADD_PROPERTY_KEY_ID } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

// Get property selection list action
export const getPropertySelectionList = (userId: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/userprops/get/${userId}`,
        next: GET_PROPERTY_LIST,
        method: 'GET',
        authorization: true
    }
});

export const setRedirects = (redirects: boolean): AppAction => ({
    type: SET_REDIRECTS,
    payload: {},
    value: redirects
});

export const setCurrentProperty = (currentProperty: string): AppAction => ({
    type: SET_CURRENT_PROPERTY,
    payload: {},
    value: currentProperty
});

export const setCurrentOwnerType = (currentOwn: string): AppAction => ({
    type: SET_CURRENT_OWNERTYPE,
    payload: {},
    value: currentOwn
});

export const setCurrentAddress = (currentAddress: string): AppAction => ({
    type: SET_CURRENT_ADDRESS,
    payload: {},
    value: currentAddress
});

export const removeProperty = (userId: string, roll: string, ownerType: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/remove-prop/${userId}/${roll}/${ownerType}`,
        next: REMOVE_PROPERTY,
        method: 'DELETE',
        authorization: true
    }
});

export const resetRemoveProperty = (): AppAction => ({
    type: RESET_REMOVE_PROPERTY,
    payload: {}
})

export const addProperty = (userId: string, apiPayload: Record<string, unknown>): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/add-prop/${userId}`,
        next: ADD_PROPERTY,
        method: 'PUT',
        data: apiPayload,
        authorization: true
    }
});

export const alternateAddPropertyKey = (): AppAction => ({
    type: ALTERNATE_ADD_PROPERTY_KEY_ID,
    payload: {}
})

export const resetAddProperty = (): AppAction => ({
    type: RESET_ADD_PROPERTY,
    payload: {}
})